import { createRoot } from 'react-dom/client';

// Import polyfills first
import './lib/polyfills.ts';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import App from './App.tsx';
import { bootstrapNative } from '@/lib/nativeBootstrap';
import './index.css';

// Theme native system bars / hide iOS keyboard accessory bar before paint.
// No-op on the web.
bootstrapNative();

// FIXME: a custom font should be used. Eg:
// import '@fontsource-variable/<font-name>';

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
